var app = angular.module('directives.locationSelect', []);

    require('./directives/locationSelect.js');
    require('./stylesheets/styles.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/locationSelect/index.js
 ** module id = 173
 ** module chunks = 1
 **/